import { combineReducers } from "redux";
import sidebarReducer from "./sidebarReducer";
import customerListingReducer from "./customerListingReducer";
import permittedActionsReducer from "./permittedActionsReducer";
const reducer = combineReducers({
  sidebar: sidebarReducer,
  customerListing: customerListingReducer,
  permittedActions: permittedActionsReducer
});

export default reducer;
